import { Link } from "react-router-dom";
import { useEffect } from "react";
// Components
import ResetLocation from "../../helpers/ResetLocation";
// Data
import careers from "../../data/careers";
import './careers.css';

const Careers = () => {
    useEffect(() => {
        document.title = "Karriere | Casaantonio e piccolo gió";
    }, []);

    return (
        <main className="careers">
            <h2>Karriere</h2>
            <h3>🚀 Du brennst für das, was du tust, bringst Fachwissen mit und hast eine starke Arbeitseinstellung? Wenn du glaubst, dass du unser Team bereichern kannst, bist du vielleicht genau die richtige Person für uns! 🌟</h3>
            
            {careers.length > 0 ? (
                <section className="careers__inner">
                    {careers.map((career) => (
                        <section key={career.id} className="careers__listings">
                            <section>
                                <h4>{career.title}</h4>
                                <p>{career.description}</p>
                                <hr />
                            </section>
                            <Link to="/contact" onClick={ResetLocation}>Jetzt bewerben</Link>
                        </section>
                    ))}
                </section>
            ) : (
                <section className="careers__empty">
                    <p>Aktuell gibt es keine offenen Stellen. Aber keine Sorge – großartige Möglichkeiten warten immer gleich um die Ecke! 🚀</p>
                    <p>Bleib auf dem Laufenden, indem du uns folgst oder später nochmal vorbeischaust. Wenn du denkst, dass du perfekt zu uns passt, kannst du dich gerne trotzdem <Link to="/contact">bei uns melden</Link>!</p>
                </section>
            )}
        </main>
    );
};

export default Careers;
